import gql from 'graphql-tag';

const UPDATE_TEAM = gql`
  mutation updateTeam($data: TeamUpdateInput!, $where: TeamWhereUniqueInput!) {
    updateTeam(data: $data, where: $where) {
      id
      name
      description
      org {
        id
        name
      }
      members {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      subscribers {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      subscribedTeams {
        id
        name
        members {
          id
          name
          username
          avatar {
            id
            key
          }
        }
      }
      subscriberTeams {
        id
        name
        members {
          id
          name
          username
          avatar {
            id
            key
          }
        }
      }
      leader {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      createdBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`;

export default UPDATE_TEAM;
